import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-bold mb-4">BWarga</h3>
            <p className="text-gray-400">
              Solusi digital terpadu untuk manajemen perumahan modern
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Dukungan</h4>
            <ul className="space-y-2 text-gray-400">
              <li>
                <button
                  onClick={() => navigate("/bantuan")}
                  className="hover:text-white transition-colors bg-transparent border-none cursor-pointer p-0 text-gray-400"
                >
                  Bantuan
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    sessionStorage.setItem("scrollPosition", window.scrollY);
                    navigate("/privasi");
                  }}
                  className="hover:text-white transition-colors bg-transparent border-none cursor-pointer p-0 text-gray-400"
                >
                  Kebijakan Privasi
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    sessionStorage.setItem("scrollPosition", window.scrollY);
                    navigate("/syarat-ketentuan");
                  }}
                  className="hover:text-white transition-colors bg-transparent border-none cursor-pointer p-0 text-gray-400"
                >
                  Syarat & Ketentuan
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
          <p>&copy; 2026 BWarga. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
